import{DEFAULT_ALGOLIA_HIERARCHY_DIVIDER as t}from"../../consts/hierarchy.js";const o=(o,r=t)=>o.split(r).length;export{o as getLevelFromHierarchy};
